var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-in-top"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"error-notification-container"},[_c('div',{staticClass:"error-notification"},[_c('img',{attrs:{"src":require('@/assets/img/error.svg')}}),_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }